












































































































































































































































































































































































































































































































































































declare var window: any;
import { Component, Vue } from 'vue-property-decorator';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import Referrals from './Referrals.vue';
import SupportingDocuments from './SupportingDocuments.vue';
import JobApplyFlow from './JobApplyFlow.vue';
import { vxm } from '@/store.vuex';
import { Job } from '@/models/jobs/job';
import { Referral } from '../models/referrals/referral';
import { ApplyRequestWrapper } from '../models/jobs/jobapply';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import router from '../../router';
import JobMainInfo from '@/components/Commons/JobMainInfo.vue';
import { CommonUserInfo } from '../models/referrals/commonuserinfo';
import ReferralProgramusd from './SvgIcons/ReferralProgramusd.vue';
import ReferralProgramgbp from './SvgIcons/ReferralProgramgbp.vue';
import MessageModal from './Commons/MessageModal.vue';
import { JobTagConfig } from '../models/jobs/jobtagconfig';
import { CandidatePortalClientCommonInfo } from '../models/utility/lookup';
//import JobPostingJsonLD from './JsonLD/JobPostingJsonLD.vue';
import { Company } from '../models/company/companyprofile';
import SimilarJobs from '@/components/Commons/SimilarJobs.vue';
import SimilarJobsAlert from '@/components/Commons/SimilarJobsAlert.vue';
import { getJobTypeText } from './MyJobs/MyJobsUtils';
import FindJobsLink from './Registration/FindJobsLink.vue';
import QuickJobApplyPopup from '@/components/QuickApply/QuickJobApplyPopup.vue';
import sanitizeHtml from 'sanitize-html';
import GDPR from './Registration/GDPR.vue';

Vue.use
(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'JobDetails',
  components: {
    Jobseeker,
    Myreferrals,
    Referrals,
    SupportingDocuments,
    JobApplyFlow,
    ReferralProgramusd,
    ReferralProgramgbp,
    JobMainInfo,
    //JobPostingJsonLD,
    SimilarJobs,
    SimilarJobsAlert,
    FindJobsLink,
    GDPR
  },
})
export default class JobDetails extends Vue {

  private jobDetailsError: string = '';
  private showDetail: boolean = false;
  private job: Job[] = [];
  private distance: number = 0;
  private isExpandedJob: boolean = false;
  private isJobApplied: boolean = false;
  private hideApplyButton: boolean = false;
  private jobDetail: any[] = [];
  private showApplyButton: boolean = false;
  $wlToastr: any;
  $moment: any;
  private bookmarks: any[] = [];
  public JOBPOSTING_ASSIGNMENT_STATUS_SCREENING = '20';
  public JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW = '30';
  public JOBPOSTING_ASSIGNMENT_STATUS_REVIEW = '35';
  public SCREENING_STATUS_ALERT = 'Your application is being screened';
  public REVIEW_STATUS_ALERT = 'Your application is being reviewed';
  public INTERVIEW_STATUS_ALERT = 'You’ve been selected for an interview';
  public INTERVIEW_SUB_STATUS_COMPLETED = 'Completed';
  public INTERVIEW_SUB_STATUS_CANCELLED = 'Cancelled';
  private job_;
  public localjobs: Job[] = [];
  public message = 'Your application is being reviewed';
  private externalUrl = '';
  public externalJobId = '';


  private skills: any[] = [];
  private categories: any[] = [];
  private industries: any[] = [];
  private facilities: any[] = [];
  private CompanyInfo: Company = new Company();

  private showDoorwayPages: boolean = false;


  private MaxDescriptionLength: number = 255;
  private ShowFullDescription: boolean = false;
  private MetaDescriptionMaxLength: number = 200;

  private showReadMore: boolean = false;
  private isTermsChecked = { marketingEmailFlag: false, tosEmailFlag: false };

  get enableAnonymousSavedJobs() {
    return vxm.configs.getGlobalConfigValue('ENABLE_ANONYMOUS_SAVED_JOBS');
  }

  get enableApplyButtonOnTop() {
    return vxm.configs.getGlobalConfigValue('ENABLE_APPLY_BUTTON_ON_TOP_OF_JOB_DESCRIPTION');
  }

  get isAnonymousFindJobsEnabled() {
    return !vxm.configs.getGlobalConfigBooelanValue('DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN')
  }

  get JobAdminComment(): string {

    document.addEventListener('DOMContentLoaded', function() {
      const contentSection = document.getElementById('MyJobsAdminCommentsSection');
      const readMoreLink = document.getElementById('readMoreLink');

      if (contentSection && readMoreLink) {
        // Show "Read More" link only if the content exceeds the max height
        if (contentSection.scrollHeight > contentSection.clientHeight) {
          readMoreLink.style.display = 'inline';
        }
      }
    });

    return vxm.jobs.UserJob.adminComment || vxm.jobs.JobAdminMessage;
  }
  handleIframeLoad(event) {
    const iframe = event.target;

    const body = iframe.contentDocument.body;
    const html = iframe.contentDocument.documentElement;

    const height = Math.max(
      body.getBoundingClientRect().height,
      body.scrollHeight,
      html.scrollHeight,
      html.getBoundingClientRect().height
    );

    iframe.style.height = `${Math.ceil(height)}px`;
  }
  get jobDescriptionWithoutPageCss() {
    return vxm.configs.getGlobalConfigBooelanValue('JOB_DESCRIPTION_WITHOUT_PAGE_CSS');
  }
  get epUrl() {
    return new URL(vxm.configs.getGlobalConfigValue('WORKLLAMA_APP_REFERRAL_URL_IMAGE') || 'https://hiring.workllama.com').origin;
  }
  get autoCommOptEnable() {
     return vxm.configs.getGlobalConfigBooelanValue('AUTO_COMM_OPT_IN_ENABLED');
  }
  get enableApplyBtn(): boolean {
    if (this.autoCommOptEnable && (!this.isTermsChecked.tosEmailFlag)) {
      return false;
    }
      return true;
  }
  gdpr(gdprObj: any) {
    this.isTermsChecked = gdprObj;
  }

  get isDynamicHeaderInjectionEnabled() {
    const showHtml = vxm.configs.getGlobalConfigValue('HEADER_HTML') ? true : false
    if (vxm.configs.IsConfigJSONEnabled) {
      return showHtml;
    } else {
      return vxm.configs.getGlobalConfigValue('ENABLE_DYNAMIC_HEADER_INJECTION') && showHtml;
    }
  }

  get showWidgetsPanel(): boolean {
    return (
      this.showDoorwayPages || this.showSimilarJobs || this.showSimilarJobsAlert
    );
  }

  get referralEnabled() {
    return vxm.configs.isReferralEnabled('REFERRAL_ENABLED');
  }

  get showSimilarJobs(): boolean {
    return vxm.configs.getGlobalConfigBooelanValue('WL_SIMILAR_JOB_FEATURE_ENABLED')
  }
  get ShowGuidedSignup(): boolean {
    return vxm.configs.GuidedSignupEnabled;
  }

  get showSimilarJobsAlert(): boolean {
    return (
      vxm.configs.getGlobalConfigValue('ENABLE_SIMILAR_JOBS_ALERT') &&
      !vxm.configs.getGlobalConfigValue('ENABLE_JOBALERT_V2')
    );
  }

  get getDynamicReferButtonText(){
    return vxm.jobs.BrandingInfo.DYNAMIC_REFER_BUTTON_TEXT ? 
    vxm.jobs.BrandingInfo.DYNAMIC_REFER_BUTTON_TEXT : 
    this.$t('findjobs.button.refer');
  }

  expandContent(event) {
    event.preventDefault();
    const contentSection = document.getElementById('MyJobsAdminCommentsSection');
    const readMoreLink = document.getElementById('readMoreLink');

    if (contentSection) {
      contentSection.classList.add('expanded');
      if (readMoreLink) {
        readMoreLink.style.display = 'none';
      }
    }
  }
  getDisciplineList(job) {
    console.log('facility image' + job.facility);
    if (job.jobPostingMetaData && Array.isArray(job.jobPostingMetaData)) {
      const disciplineField = job.jobPostingMetaData.find(
        (field) => field.label === 'Discipline',
      );
      if (
        disciplineField &&
        job.jobPostingCustomData &&
        job.jobPostingCustomData[disciplineField.name]
      ) {
        const disciplineIds = job.jobPostingCustomData[
          disciplineField.name
        ].split(',');
        if (Array.isArray(disciplineIds)) {
          return disciplineIds.map((id) => {
              return disciplineField.displayList[
                disciplineField.valueList.indexOf(id)
              ];
          }).filter(fieldValue => fieldValue && fieldValue != null);
        }
        return [];
      }
      return [];
    }
    return [];
  }

  get hideMyJobsStatus() {
    return vxm.configs.getGlobalConfigBooelanValue('HIDE_MY_JOB_STATUS');
  }

  showHeader() {
    return (
      !this.hideMyJobsStatus &&
      this.job_ &&
      this.job_.jobPostingAssignmentStatus &&
      (this.job_.jobPostingAssignmentStatus ===
        this.JOBPOSTING_ASSIGNMENT_STATUS_SCREENING ||
        this.job_.jobPostingAssignmentStatus ===
          this.JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW ||
        this.job_.jobPostingAssignmentStatus ===
          this.JOBPOSTING_ASSIGNMENT_STATUS_REVIEW)
    );
  }

  showInterviewSlot() {
    return (
      this.job_.subStatusDescription != this.INTERVIEW_SUB_STATUS_COMPLETED &&
      this.job_.subStatusDescription != this.INTERVIEW_SUB_STATUS_CANCELLED
    );
  }

  goToUpload(jobPosting: any, externalJobUrl: string) {
    const jid = jobPosting.jobPostingId;
    const vm = this;
    if (!vxm.users.getToken) {
      if(externalJobUrl === null)
      this.setNavigation('JobDetails:' + jid);
      if (externalJobUrl != null) {
        this.showPopup(
          'Login',
          this.$t('Jobdetails_LoginPrompt').toString(),
          jid,
        );
      } else if (vxm.configs.getGlobalConfigValue('QUICK_JOB_APPLY_ENABLED')) {
        vxm.jobs.setJobID(parseInt(jid, 10));
        this.$router.push({ path: `/quickapply/${jid}?apply=true` });
      } else {
        this.$cookies.set('SubmitJobApplicationId', jid, 600);
        this.$router.push({ name: 'Login' });
      }
    } else {
      if (externalJobUrl != null) {
        this.showPopup(
          externalJobUrl,
          vxm.jobs.BrandingInfo.JOB_REDIRECTION_PROMPT!==''?
          vxm.jobs.BrandingInfo.JOB_REDIRECTION_PROMPT.toString():
          this.$t('Jobdetails_RedirectionPrompt').toString(),
          jid,
        );
      } else {
        this.applyJob(jid);
      }
    }
    vxm.users.Rudderstack.trackEvent('Job Apply Selected',
      {
      jobPostingId: jid,
        jobPostingName : jobPosting.jobPostingName
    });
  }

  applyJob(jid: string) {
    if (this.isJobApplied) {
      vxm.jobs.setJobID(parseInt(jid, 10));
      const jobApply = new ApplyRequestWrapper();
      jobApply.accessToken = vxm.users.getToken;
      jobApply.applyRequest.jobPostingId = parseInt(jid, 10);
      jobApply.applyRequest.companyCode = this.$store.state.jobs.companyCode;
      const respPromise: any = vxm.jobs.getNexSteps(jobApply);
      this.$modal.show('survey-spinner');
      Promise.all([respPromise]).then((resp) => {
        this.$modal.hide('survey-spinner');
        this.processJobApplicationResponse(resp, jid);
      });
    } else {
      vxm.jobs.setJobID(parseInt(jid, 10));
      const jobApply = new ApplyRequestWrapper();
      jobApply.accessToken = vxm.users.getToken;
      jobApply.applyRequest.jobPostingId = parseInt(jid, 10);
      // jobApply.applyRequest.referralCode = this.$route.params.referralCode;
      jobApply.applyRequest.companyCode = this.$store.state.jobs.companyCode;

      const respPromise: any = vxm.jobs.getNexSteps(jobApply);
      this.$modal.show('survey-spinner');
      Promise.all([respPromise]).then((resp) => {
        this.$modal.hide('survey-spinner');
        this.processJobApplicationResponse(resp, jid);
      });
    }
  }

  showPopup(externalJobUrl: string, message: string, jid: string) {
    this.externalUrl = externalJobUrl;
    this.externalJobId = jid;
    this.$modal.show(
      MessageModal,
      {
        body: message,
        onOk: () => this.onPopUpOk(externalJobUrl, jid)(),
        onCancel: () => this.onPopUpCancel(jid),
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }
  onPopUpCancel(jid) {
    vxm.users.Rudderstack.trackEvent('Clicked on External Job Apply', {
      buttonClicked: 'CANCEL',
      jobPostingId: jid,
    });
  }
  onPopUpOk(externalJobUrl, jid) {
    vxm.users.Rudderstack.trackEvent('Clicked on External Job Apply', {
      buttonClicked: 'OK',
      jobPostingId: jid,
    });
    return externalJobUrl == 'Login'
      ? this.openExtUrlWindowWithoutLogin
      : this.openExtUrlWindow;
  }

  openExtUrlWindow() {
    this.applyJob(this.externalJobId);
    window.open(this.externalUrl, '_blank');
  }

  openExtUrlWindowWithoutLogin() {
    this.$router.push({ name: 'Login' });
  }

  processJobApplicationResponse(resp, jid: string) {
    let apply = resp[0]['data'];
    if (apply.nextPage === 'otpauthentication') {
      if (vxm.utility.useLoginSignupV2) {
        this.setNavigation('JobDetails:' + jid);
      }
      this.$router.push({ name: 'Verification' });
    }
    if (apply.questionareInfo) {
      localStorage.hasBranchedQuestions = apply.questionareInfo.hasBranchedQuestions;
      localStorage.questionTemplate = apply.questionareInfo.questionTemplateId;
    }
    // error code 1001 resume
    if (
      apply.errorCode === '1001' ||
      apply.nextPage === 'questionnaire' ||
      apply.nextPage === 'supportinginfo'
    ) {
      this.$cookies.remove('SubmitJobApplicationId');
      if(!this.externalUrl){
        this.showApplyButton = false;
        localStorage.nextpage =
        apply.errorCode === '1001' ? 'resume' : apply.nextPage;
        localStorage.followupPage = apply.followingPage
        this.isJobApplied = true;
        return;
      }
    }

    if (apply.errorCode === '1002') {
      this.showMessage(apply, jid);
      return;
    }

    if (apply.nextPage === 'success') {
      this.showMessage(apply, jid);
      return;
    }
    this.showMessage(apply, jid);
  }

  showMessage(value, jid: string) {
    if (value) {
      if (!value.success) {
        if (value.errorCode === '1002') {
          const errorMessageText = value.errorMessage;
          this.$wlToastr('error', errorMessageText, this.$t('MyJobListing_JobApplication'));
        }
      } else {
        this.$cookies.remove('SubmitJobApplicationId');
        if (value.nextPage === 'success') {
          vxm.users.Rudderstack.trackEvent("Job Apply Submitted", { jobPostingId: jid });
          const successMessage = this.$t('jobs.successfully.applied');
          this.$wlToastr('success', successMessage, this.$t('MyJobListing_JobApplication'));
          vxm.jobs.setAppliedJob(jid);
          if (
            vxm.configs.getGlobalConfigValue('GSU_AFTER_JOB_APPLY') &&
            vxm.configs.GuidedSignupEnabled &&
            !vxm.jobs.GuidedSignUpOccured
          ) {
            this.$router.push({ name: 'GuidedSignup' });
          } else {
            this.$router.push({
              name: 'JobApplicationSuccess',
              params: { jid },
            });
          }
        }
      }
    }
  }

  setNavigation(path: string) {
    this.$cookies.set('NavigateTo_ID', path, 600);
    let apply = this.$route.query.apply;
    if (vxm.utility.useLoginSignupV2) {
      apply = undefined === apply ? 'true' : apply;
    }
    this.$cookies.set('apply', apply, 600);
  }

  bookmarkClass(job) {
    if (
      job.bookmarkStatus &&
      job.bookmarkStatus === 'A' &&
      job.hasAppliedJob != true
    ) {
      return 'fa fa-bookmark secondary-color';
    } else {
      return 'fa fa-bookmark-o remove-color';
    }
  }

  parseUrl(videoURL: string): string {
    const nArr = videoURL.split('=');
    return nArr[1];
  }



  goToReferral(job: Job) {
    let jid = job.jobPostingId + '';
    vxm.referrals.setJobID(parseInt(jid, 10));
    vxm.referrals.setRefferedJob(job.jobPostingName);
    this.$cookies.remove('referralSuccess');
    this.$cookies.remove('frictionLess');
    const referral = new Referral();
    referral.jobPostingId = parseInt(jid, 10);
    if (vxm.users.isLoggedIn === false) {
      vxm.referrals.setReferral(referral);
      this.$router.push({ name: 'JobShare', params: { JobID: jid } });
    } else {
      referral.userFullName =
        vxm.users.myUserProfile.firstName +
        ' ' +
        vxm.users.myUserProfile.lastName;
      referral.email = vxm.users.myUserProfile.email;
      // referral.referralCode = this.$route.params.referralCode;
      referral.companyCode = vxm.jobs.BrandingInfo.companycode;
      referral.referredJobLocation = job.facility.name;
      console.log(referral);
      vxm.referrals.setReferral(referral);
      vxm.referrals.jobShareReferral(referral);
    }
    vxm.users.Rudderstack.trackEvent("Job Refer Selected", {
      jobPostingId: job.jobPostingId,
     jobPostingTitle : job.jobPostingName
    });
  }

  getJobTagStyle(jobTagObj) {
    let styleObj = {};
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.fontColor
    ) {
      styleObj['color'] = jobTagObj.meta.style.fontColor;
    }
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.backgroundColor
    ) {
      styleObj['background'] = jobTagObj.meta.style.backgroundColor;
    }
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.backgroundColorOpacity
    ) {
      styleObj['opacity'] = jobTagObj.meta.style.backgroundColorOpacity;
    }
    return styleObj;
  }

  toggleReferralIndex() {
    if (this.isExpandedJob === false) {
      this.isExpandedJob = true;
    } else {
      this.isExpandedJob = false;
    }
  }

  isExpanded(): boolean {
    if (this.isExpandedJob === true) {
      return true;
    } else {
      return false;
    }
  }

  checkContentOverflow() {
    const contentSection = document.getElementById('MyJobsAdminCommentsSection');
    if (contentSection && contentSection.scrollHeight > 200) {
      this.showReadMore = true;
    }
  }

  getJobTags(jobTags: string) {
    if (jobTags) {
      let jobTagValues = new Set(jobTags);
      let jobTagConfigs: JobTagConfig[] = vxm.jobs.JobTagConfigs;
      if (jobTagConfigs && jobTagConfigs.length > 0) {
        return jobTagConfigs
          .filter((tagConf) => jobTagValues.has(tagConf.tagName))
          .sort((a, b) => a.sequence - b.sequence);
      }
    }
    return [];
  }

  goBackRoute() {
    this.$router.go(-1);
  }

  getDistance(job: Job) {
    if (job.distance) {
      if (job.distance > 0.1) {
        return job.distance.toFixed(1);
      } else {
        return '< 0.1';
      }
    } else {
      return '0.0';
    }
  }

  getCompanyDistanceUnits(): string {
    if (vxm.jobs.getCompanyDistanceUnit == 'kilometers') {
      return 'km';
    }
    return 'mi';
  }

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  JobID() {
    return parseInt(this.$route.params.JobID, 10);
  }

  jobDetails() {
    let p: Promise<any> = vxm.users.isLoggedIn
      ? vxm.jobs.getJobByID(this.JobID() + '')
      : vxm.jobs.getAnonymousJobByID(this.JobID() + '');

    return p.then((resp) => {
        if (resp.jobPostingErrors && resp.jobPostingErrors[0]) {
        this.jobDetailsError = resp.jobPostingErrors[0].jobPostingErrorMessage;
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1121){
          this.jobDetailsError = this.$t('errorcode.1121').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1122){
          this.jobDetailsError = this.$t('errorcode.1122').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1127){
          this.jobDetailsError = this.$t('errorcode.1127').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1128){
          this.jobDetailsError = this.$t('errorcode.1128').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1123){
          this.jobDetailsError = this.$t('errorcode.1123').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1129){
          this.jobDetailsError = this.$t('errorcode.1129').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1124){
          this.jobDetailsError = this.$t('errorcode.1124').toString();
        }
          return;
        }

        const jInfo: Job[] = [];
        jInfo.push(vxm.jobs.AnonymousJobByID);
        if (resp.publishedJobs && resp.publishedJobs[0]) {
          this.distance = resp.publishedJobs[0].distance;
        }
        jInfo.forEach((job) =>
        job.savedDTTM ? (job.bookmarkStatus = 'A') : (job.bookmarkStatus = 'D'),
        );
        this.jobDetail = jInfo;
    }).catch((err) => {
        console.log('err', err);
        window.WorkLLama.errorMessage = `Job #${this.JobID()} Not Found`;
        this.$router.push('/errormessage');
      });
  }

  async mounted() {
    const jobid = this.$route.params.JobID;
    const jobSlug = this.$route.params.JobSlug;
    const apply = this.$route.query.apply;
    const refer = this.$route.query.refer;
    const showReferralDetails = this.$route.query.showReferralDetails;
    const submitJobApplicationId = this.$cookies.get('SubmitJobApplicationId');

    if (!this.isLoggedIn) {
      const url = new URL(window.location.href);
      const refId = url.searchParams.get('refId');
      const uuid = url.searchParams.get('uuid');
    console.log(refId,uuid,"in job details")
      if (refId && uuid) {
        vxm.users.setRefId(refId);
        vxm.users.setUuid(uuid);
        vxm.users.setPopulateSignupPage(true);
        vxm.users.initRegisteredUser();
      }

    }
    if (localStorage.getItem('localjobs')) {
      this.localjobs = JSON.parse(localStorage.getItem('localjobs') || '[]');
      //console.log('local jobs:' + localStorage.localjobs);
    }

    //this.$modal.show("survey-spinner");
    if (localStorage.jobviewpage && localStorage.jobviewpage === 'true') {
      this.showApplyButton = true;
    } else if (
      localStorage.jobviewpage &&
      localStorage.jobviewpage === 'false'
    ) {
      this.showApplyButton = false;
    } else if (
      localStorage.nextpage &&
      (localStorage.nextpage === 'resume' ||
        localStorage.nextpage === 'supportinginfo' ||
        localStorage.nextpage === 'questionnaire')
    ) {
      this.isJobApplied = true;
    } else {
      vxm.jobs.setJobID(parseInt(jobid, 10));
      // const jobApply = new ApplyRequestWrapper();
      // jobApply.accessToken = vxm.users.getToken;
      // jobApply.applyRequest.jobPostingId = parseInt(jobid, 10);

      // jobApply.applyRequest.companyCode = vxm.jobs.BrandingInfo.companycode;
      // const respPromise: any = vxm.jobs.getNexSteps(jobApply);
      // this.$modal.show('survey-spinner');
      // Promise.all([respPromise]).then((values) => {
      //   this.$modal.hide('survey-spinner');
      //   this.processJobApplicationResponse(values);
      // });
      this.showApplyButton = true;
      this.isJobApplied = false;
    }
    this.jobDetails().then(async (x) => {
      if (apply || submitJobApplicationId) {
        this.goToUpload(this.jobDetail[0], this.jobDetail[0].externalJobUrl);
      } else if (showReferralDetails) {
        this.toggleReferralIndex();
      } else if (refer) {
        this.jobDetail.forEach((job) => this.goToReferral(job));
      }
      const job = this.jobDetail[0];

      this.skills = job.jobSkills; // jobSkills already is a list
      this.categories = []; // TBD
      this.industries = []; // TBD
      this.facilities = [...this.facilities, job.facility];
      this.updateCompanyInfo(job.companyCode);

      /*const title =
        job.isRemote === 'true' || job.isRemote === 'yes'
          ? `${job.jobPostingName} - ${job.jobPostingId} | Jobs at ${job.companyName}`
          : `${job.jobPostingName} in ${job.facility.city}, ${job.facility.state} - ${job.jobPostingId} | Jobs at ${job.companyName}`;
      document.title = title;*/

      this.updateTitleAndMetaTags(job);

      if (this.jobDetailsError) {
        const metaRobot: any = document.querySelector('meta[name="robots"]');
        metaRobot.setAttribute('content', 'noindex');
      }

      if (this.showSimilarJobs) {
        vxm.utility.setSpinnerStatus(false);
        await this.callSimilarJobs(job);
      }
      vxm.utility.setSpinnerStatus(false);
      const hostMappedURL: string = vxm.configs.getGlobalConfigValue(
        'HOST_MAPPING',
      );
      if (hostMappedURL && window.location.host.includes('workllama.com')) {
        const head = document.querySelector('head');
        if (head) {
          const canonicalURL: string = hostMappedURL + this.$route.path;
          head.append('<link rel="canonical" href="' + canonicalURL + '" />');
        }
      }
    });
    if (
      vxm.jobs.jobId &&
      vxm.jobs.UserJob &&
      vxm.jobs.jobId === vxm.jobs.UserJob.jobPostingId
    ) {
      this.job_ = vxm.jobs.UserJob;
    }
    this.checkContentOverflow();
  }

  async callSimilarJobs(job) {
    vxm.jobs.getSimilarJobs({
      jobId: job.jobPostingId,
      companyCode: vxm.jobs.BrandingInfo.companycode,
    });
  }

  // Update the page title and meta tags
  updateTitleAndMetaTags(job) {
    let title = `Apply to ${job.jobPostingName} (${this.jobTypeText(job)}) at ${
      job.companyName
    }`;
    const city = job.facility.city ? job.facility.city.trim() : '';
    const state = job.facility.state ? job.facility.state.trim() : '';
    title = `${title} - ${city}, ${state}`;
    // Update title
    document.title = title;
    const metaTag = document.querySelector('meta[property="og:title"]');
    if (!metaTag) return;
    // Update title metatag
    metaTag.setAttribute('content', title);
    this.updateDescriptionMetaTag(job);
  }

  // Update the description meta tag
  updateDescriptionMetaTag(job) {
    if (!job.jobPostingDescription) return;

    // Sanitize the description
    const description = sanitizeHtml(job.jobPostingDescription, {
      allowedTags: [],
    });

    // Take the first n chars (n -> MetaDescriptionMaxLength, eg. 200 chars)
    const metaDescription =
      description.length > this.MetaDescriptionMaxLength
        ? description.substring(0, this.MetaDescriptionMaxLength)
        : description;

    // Update description metatag
    let metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) metaTag.setAttribute('content', metaDescription);

    // Update og:description metatag
    metaTag = document.querySelector('meta[property="og:description"]');
    if (metaTag) metaTag.setAttribute('content', metaDescription);
  }

  get showAdminMessage(): string {
    if (
      this.job_.awaitingActionBy &&
      this.job_.awaitingActionBy === '01' &&
      this.job_.nextStepScheduleStartDTTM
    ) {
      var n = this.job_.nextStepScheduleStartDTTM.substring(
        this.job_.nextStepScheduleStartDTTM.indexOf('T'),
      );
      var res = n.replace(/-/g, ':');
      this.job_.nextStepScheduleStartDTTM = this.job_.nextStepScheduleStartDTTM.replace(
        n,
        res,
      );

      const startDTTM = new Date(this.job_.nextStepScheduleStartDTTM);

      const dateString = this.$moment(startDTTM).format('DD-MMM-YYYY');
      let timeStampString = this.$moment(startDTTM).format('hh:mm A');
      return `Your ${this.getJobPostingAssignmentText()} is scheduled on ${dateString} at ${timeStampString}`;
    } else {
      return this.getJobPostingAssignmentAlertStatusText();
    }
  }

  getJobPostingAssignmentAlertStatusText(): string {

    const translatedStatus = {
      '20': this.$t('MyJobIntermediateStep_ApplicationScreened').toString(),
      '30': this.$t('MyJobIntermediateStep_SelectedForInterview').toString(),
      '35': this.$t('MyJobIntermediateStep_ApplicationReviewed').toString()
    };

    return translatedStatus[this.job_.jobPostingAssignmentStatus] || '';

  }

  getJobPostingAssignmentText() {
    if (
      this.job_.jobPostingAssignmentStatus ===
      this.JOBPOSTING_ASSIGNMENT_STATUS_SCREENING
    ) {
      return 'screening';
    } else if (
      this.job_.jobPostingAssignmentStatus ===
      this.JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW
    ) {
      return 'interview';
    } else if (
      this.job_.jobPostingAssignmentStatus ===
      this.JOBPOSTING_ASSIGNMENT_STATUS_REVIEW
    ) {
      return 'review';
    }
    return '';
  }

  nextStep() {
    vxm.jobs.setJobAdminMessage(this.job_.adminComment);
    this.$router.push({
      name: 'myjobstatusWorkflowStep',
      params: { JobID: this.job_.jobPostingId },
    });
  }

  // Get the company info from the server;
  updateCompanyInfo(companyCode) {
    const candidatePortalClientCommonInfo = new CandidatePortalClientCommonInfo();
    candidatePortalClientCommonInfo.radius = vxm.jobs.FilterRadius;
    candidatePortalClientCommonInfo.latitude = vxm.jobs.latitude;
    candidatePortalClientCommonInfo.longitude = vxm.jobs.longitude;
    candidatePortalClientCommonInfo.companyCode = companyCode;
    vxm.jobs
      .getCompanyInfo(candidatePortalClientCommonInfo)
      .then((companyInfo) => {
        this.CompanyInfo = companyInfo;
      });
  }

  getJobReferralProgramExists(job) {
    if (job.companyReferralIncentive != null) {
      return job.companyReferralIncentive.companyReferralIncentiveName !== 'NA'
        ? true
        : false;
    }
    return false;
  }

  toggleReferrals() {
    this.showDetail = !this.showDetail;
  }

  getToggleValue() {
    return this.showDetail;
  }

  renderDate(xDate: Date): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return (
        'STARTING: ' +
        this.$moment(xDate).format(vxm.jobs.getCompanyDateFormat.toUpperCase())
      );
    }
    return 'STARTING: ' + this.$moment(xDate).format('DD-MMM-YYYY');
  }

  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }

  bookmarkJob(job: any) {
    let jobs = this.bookmarks.filter(
      (bookmark) => bookmark.objectId === job.jobPostingId,
    );
    if (jobs && jobs.length > 0) {
      for (let bookmark of this.bookmarks) {
        if (job.jobPostingId == bookmark.objectId) {
          if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
            job.bookmarkStatus = 'D';
            bookmark.action = 'D';
          } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
            job.bookmarkStatus = 'A';
            bookmark.action = 'A';
          }
        }
      }
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      job.bookmarkStatus = 'D';
      this.bookmarks.push({
        action: 'D',
        type: '01',
        objectId: job.jobPostingId,
      });
      vxm.users.Rudderstack.trackEvent('Job Unsaved', {
        jobPostingId: job.jobPostingId,
        jobPostingTitle: job.jobPostingName,
      });
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      job.bookmarkStatus = 'A';
      this.bookmarks.push({
        action: 'A',
        type: '01',
        objectId: job.jobPostingId,
      });
      vxm.users.Rudderstack.trackEvent('Job Saved', {
        jobPostingId: job.jobPostingId,
        userAppliedtoJob: job.hasAppliedJob,
        jobPostingTitle: job.jobPostingName,
      });
    }

    let bookmarkIcon = this.$refs['bookmark_' + job.jobPostingId];
    if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      bookmarkIcon[0].classList = ['fa fa-bookmark secondary-color bookmark-icon'];
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      bookmarkIcon[0].classList = [
        'fa fa-bookmark-o remove-color bookmark-icon',
      ];
    }
    let req = {
      sessionToken: '13223',
      bookmarks: this.bookmarks,
    };
    if (this.bookmarks && this.bookmarks.length > 0) {
      vxm.jobs.bookmarkJob(req).then((resp) => {});
    }
  }

  destroyed() {
    localStorage.nextpage = '';
    vxm.jobs.setJobAdminMessage('');
  }

  getFirstCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }

  formattingJobDescription(jobDescription: any) {
    if (
      !this.ShowFullDescription &&
      jobDescription &&
      jobDescription.length > this.MaxDescriptionLength
    ) {
      return `${jobDescription.substring(0, this.MaxDescriptionLength)}...`;
    }
    return jobDescription;
  }

  toggleSeeMore() {
    this.ShowFullDescription = !this.ShowFullDescription;
  }

  saveJob(job: Job) {
    const vm = this;
    this.localjobs.push(job);
    localStorage.setItem('localjobs', JSON.stringify(this.localjobs));
    vxm.utility.setLocaljobs(this.localjobs);
    vm.$wlToastr('success', vm.$t('MyJobListing_JobSavedSuccess'), vm.$t('savedJobs.text'));
  }

  deleteSavedJob(job: Job) {
    const vm = this;
    console.log('got job:' + job.jobPostingId);
    this.localjobs.forEach((item, index) => {
      if (item.jobPostingId == job.jobPostingId) {
        this.localjobs.splice(index, 1);
        console.log('deleting job');
      }
    });
    localStorage.setItem('localjobs', JSON.stringify(this.localjobs));
    vxm.utility.setLocaljobs(this.localjobs);
    vm.$wlToastr('success', vm.$t('MyJobListing_JobUnsavevSuccess'), vm.$t('savedJobs.text'));
  }

  isSavedJob(jobid) {
    const found = this.localjobs.find(
      (element) => element.jobPostingId == jobid,
    );
    console.log('job found:' + found);
    return found;
  }

  jobTypeText(job: Job): string {
    return this.$t(getJobTypeText(job)).toString();
  }

  closeCard() {
    if (vxm.users.isNewUser && !vxm.jobs.SkipGuidedSignUpOnApplication) {
      vxm.users.setNewUser(false);
      if (this.ShowGuidedSignup) {
        this.$router.push({ name: 'GuidedSignup' });
      } else {
        this.$router.push({ name: 'Findjobs' });
      }
    } else if (this.$route.query.goBackRoute) {
      this.$router.push({ path: String(this.$route.query.goBackRoute) });
    }
    else if (window.history.length > 1) {
      // If there's a previous page, go back to it.
      this.$router.go(-1);
    }
    else {
      this.$router.push({ name: 'Findjobs' });
    }
  }

  get isShareSocialLinksEnabled() {
    return vxm.configs.getGlobalConfigValue('SHOW_JOB_SHARE_SOCIAL_LINKS');
  }

  fbshareCurrentPage() {
    const shareUrl = this.shareUrl("referral")
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl)+'',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    );
    return false;
  }

  tweetJobReferralLink() {
    const shareUrl = this.shareUrl("referral")
    window.open(
      'https://twitter.com/share?url=' + encodeURIComponent(shareUrl) + '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    );
    return false;
  }

  linkedinshareJobReferralUrl() {
    const shareUrl = this.shareUrl("referral")
    window.open(
      'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(shareUrl) + '&title=',
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    );
    return false;
  }

  shareLinkEmail(jobName: string) {
    const shareUrl = this.shareUrl("referral")
    const emailSub = this.$t('jobDetail.shareLinkEmailSubject', { jobName }).toString();
    const emailBody = this.$t('jobDetail.shareLinkEmailBody', { shareLink: shareUrl }).toString();
    window.open(
      "mailto:?" +
        "&subject=" +
        encodeURIComponent(emailSub) +
        "&body=" +
        encodeURIComponent(emailBody)
    );
  }

  shareLinkCopy() {
    const shareUrl = this.shareUrl("referral")
    window.navigator.clipboard.writeText(shareUrl)
    .then(() => {
      this.$wlToastr('info', this.$t('referrals.copied'), window.document.title);
    });
  }
  shareUrl(medium) {
    // Create a URL object
    const url = new URL(window.location.href);
    // Get the search parameters from the URL
    const params = new URLSearchParams(url.search);
    params.set('utm_source', 'workllama_share');
    params.set('utm_campaign', "tp");
    params.set('utm_medium', medium);
    url.search = params.toString();

    // Get the new URL
    return url.toString();
  }
}
